import { lazy } from 'react'

export const EditFunctionalitiesModalAsync = lazy(() => import('./EditFunctionalitiesModal')
    .then((component) => ({ default: component.EditFunctionalitiesModal }))
)
